<template>
  <el-container>
    <el-header class="table-header">
      <el-button type="primary" size="mini" @click="submit(JSON.stringify(form))">{{$t('common.Save')}}</el-button>
<!--      <el-button size="mini" @click="cancel">取消</el-button>-->
    </el-header>
    <el-main class="table-main">
    <el-form ref="form" :rules="CommitForm" label-width="80px" :model="form" size="mini" class="table-form">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item :label="$t('common.Code')" prop='code'>
            <el-input v-model="form.code" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('common.Name')" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('base.info.org.Type')" prop="type">
            <el-select v-model="form.type">
              <el-option
                v-for="item in optionsType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('base.info.org.Parent')" prop="parentName">
            <el-input v-model="parent.name" readonly>
              <el-button slot="append" icon="el-icon-search" @click="updateParent"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('common.Remark')" prop="remark">
            <el-input v-model="form.remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
       <!-- <el-col :span="6">
          <el-form-item label="状态" prop="status">
              <template>
                <el-select v-model="form.status">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="60%">
      <el-input v-model="searchByName" :placeholder="$t('base.info.org.SearchByName')" size="small" style="width:88%;"></el-input>&nbsp;&nbsp;<el-button
      size="small" type="primary" @click="serachByName">{{$t('common.Search')}}
    </el-button>
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width:100%">
        <el-table-column
          type="index"
        >
        </el-table-column>
        <el-table-column prop="code" :label="$t('common.Code')" align="center">
        </el-table-column>
        <el-table-column prop="name" :label="$t('common.Name')" align="center">
        </el-table-column>
      </el-table>
      <div align="center">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          layout="prev, pager, next"
          :total="pageInfo.count"
          :current-page="pageInfo.curIndex"
          :page-size="pageInfo.pageCount">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">{{$t('common.Cancel')}}</el-button>
        <el-button type="primary" @click="selectSubmit" size="mini">{{$t('common.Ok')}}</el-button>
      </div>
    </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      form: {},
      title: '',
      dialogFormVisible: false,
      searchByName: '',
      tableData: [],
      parent: [],
      optionsType: [{
        value: '数据字典配置',
        label: '数据字典配置'
      }, {
        value: 'system_conf',
        label: 'system_conf'
      }, {
        value: 'org_type',
        label: 'org_type'
      }],
      options: [{
        value: 40,
        label: '停用'
      }, {
        value: 50,
        label: '正常'
      }],
      value: '',
      CommitForm: {
        name: [{required: true, trigger: 'blur', message: '组织名称不能为空'}],
        code: [{required: true, trigger: 'blur', message: '组织名称不能为空'}]
      },
      currentRow: '',
      pageInfo: {
        pageCount: 6, // 一页显示数目
        curIndex: 1, // 当前页数
        count: 100// 总条目数
      }
    }
  },
  methods: {
    serachByName () {
      this.convert(this.pageInfo.pageCount, 0, this.searchByName)
    },
    handleCurrentChange (val) {
      this.currentRow = val
    },
    convert (size, indexPage, name) {
      let param = {
        data: {
          name: name,
          code: this.form.code
        },
        pageSize: size,
        pageIndex: indexPage
      }
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/org/findWhenUpdate',
        data: JSON.stringify(param),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        this.tableData = response.data.data
        this.pageInfo.curIndex = response.data.curIndex + 1
        this.pageInfo.count = response.data.count
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    currentChange (val) {
      this.convert(this.pageInfo.pageCount, val - 1, this.searchByName)
    },
    sizeChange (val) {
      this.convert(val, 0, this.searchByName)
    },
    selectSubmit () {
      this.parent = this.currentRow
      this.dialogFormVisible = false
    },
    updateParent () {
      this.dialogFormVisible = true
      this.title = this.$t('base.info.org.EditParent')
      this.convert(this.pageInfo.pageCount, 0, this.searchByName)
    },
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.parentCode = this.parent.code
          this.$axios({
            method: 'post',
            url: this.global.BASE_INFO + '/org/updateOrg',
            data: JSON.stringify({data: this.form}),
            headers: {
              certificate: Cookies.get(`token_${window.location.port}`),
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error'
              })
            }
            this.$router.push({path: '/org'})
            let tabItem = this.$store.getters.rightNav
            this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        }
      })
    },
    cancel () {
      this.$router.push({path: '/org'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    }
  },
  created () {
    let rows = this.$route.params.row
    this.parent.name = rows.parentName
    this.parent.code = rows.parentCode
    this.form = rows
  },
  message () {
    const h = this.$createElement
    this.$notify({
      title: '提示',
      message: h('i', {style: 'color: teal'}, ''),
      duration: 6000
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/org/updateOrg.vue